function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.204659 13.4722C0.181326 13.5702 0.211076 13.6734 0.282243 13.7452C0.351076 13.8146 0.452576 13.8467 0.555243 13.8228C0.555243 13.8228 4.37608 12.9227 4.39824 12.911L1.11699 9.62976C1.10474 9.65134 0.204659 13.4722 0.204659 13.4722Z",
  fill: "#1B75BB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.14843 1.57971L1.90086 8.82727L5.20066 12.1271L12.4482 4.87951L9.14843 1.57971Z",
  fill: "#1B75BB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3603 3.96616L13.5668 3.75966C14.1356 3.19149 14.1356 2.26633 13.5668 1.69758L12.3296 0.460909C12.0542 0.184409 11.6879 0.0333252 11.2982 0.0333252C10.9086 0.0333252 10.5422 0.184992 10.2669 0.460909L10.0604 0.666242L13.3603 3.96616Z",
  fill: "#1B75BB"
});

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.2563ce38.svg";
export { ForwardRef as ReactComponent };